<template>
    <div>
        <template v-if="statistics">
            <div class="page-group-title"><span>活动数据</span></div>
            <el-card shadow="never" class="statistics-box">
                <el-row :gutter="20">
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.pv}}</p><p class="color-info">PV</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.uv}}</p><p class="color-info">UV</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.registerNum}}人</p><p class="color-info">注册人数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.lotteryUserNum}}人</p><p class="color-info">参与用户总数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.initiativeUserNum}}人</p><p class="color-info">主动参与用户数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.byShareUserNum}}人</p><p class="color-info">被分享参与活动用户数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.winnerUserNum}}人</p><p class="color-info">中奖用户数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.lotteryNum}}次</p><p class="color-info">抽奖总次数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.winnerNum}}次</p><p class="color-info">中奖次数</p></el-col>
                </el-row>
            </el-card>

            <div class="page-group-title"><span>推荐演出数据</span></div>
            <div class="page-list-box">
                <el-table
                    :data="statistics.activityDataList"
                    border
                    style="width: 100%"
                    size="small"
                >
                <el-table-column prop="activityId" label="演出ID">
                </el-table-column>
                <el-table-column prop="activityTitle" label="演出名称" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="clickNum" label="演出点击人数">
                </el-table-column>
                <el-table-column prop="orderNum" label="下单数">
                </el-table-column>
                <el-table-column prop="orderAmount" label="下单金额">
                </el-table-column>
            </el-table>
            </div>
        </template>
        <template v-if="$utils.have('/lottery/activity/statistics/detail')">
            <div class="page-group-title"><span>数据列表</span></div>
            <div class="page-filter-box">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-date-picker type="datetime" v-model="params.startTime" placeholder="参与开始时间" value-format="yyyy-MM-dd HH:mm:ss" size="small"></el-date-picker>
                    </el-col>
                    <el-col  :span="4">
                        <el-date-picker type="datetime" v-model="params.endTime" placeholder="参与结束时间" value-format="yyyy-MM-dd HH:mm:ss" size="small"></el-date-picker>
                    </el-col>
                    <el-col  :span="4">
                        <el-select v-model="params.status" placeholder="请选择" size="small">
                            <el-option label="不限制状态" :value="0"></el-option>
                            <el-option label="仅看未中奖的" :value="1"></el-option>
                            <el-option label="仅看中奖的" :value="2"></el-option>
                        </el-select>
                    </el-col>
                    <el-col  :span="4">
                        <el-input
                            placeholder="请输入参与用户手机号"
                            v-model="params.telephone"
                            size="small"
                        ></el-input>
                    </el-col>
                    <el-col :span="8" class="page-filter-btns">
                        <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
						<el-button type="primary" icon="el-icon-download" size="small" @click="download" :loading="downLoading"
								v-if="$utils.have('/lottery/activity/export/winAddress') && dataList &&  dataList.length > 0" >导出中奖/实名信息</el-button>
                        <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>						
                    </el-col>
                </el-row>
            </div>
            <div class="page-list-box">
                <el-table
                    :data="dataList"
                    border
                    style="width: 100%"
                    v-loading="listLoading"
                    size="small"
                    stripe
                >
                    <el-table-column prop="nickName" label="昵称" min-width="100" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="telephone" label="手机号" min-width="120">
                    </el-table-column>
                    <el-table-column prop="createTime" label="抽奖时间" min-width="150">
                    </el-table-column>
                    <el-table-column prop="lotteryResult" label="获奖状态">
                    </el-table-column>
                    <el-table-column prop="prizeInfo" label="中奖信息" show-overflow-tooltip>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="data" class="page-pagination-box">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="getDataList"
                    :current-page.sync="params.pageNo"
                    :page-sizes="$pageSizes"
                    :page-size.sync="params.pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="data.totalCount || 0">
                </el-pagination>
            </div>
        </template>
    </div>
</template>
<script>
import {downloadFileTmp} from '@/assets/js/commonApi.js';
const defaultParams = {
    "endTime": "",
    "lotteryActivityId": 0,
    "pageNo": 1,
    "startTime": "",
    "status": 0,
    "telephone": ""
};
export default {
    data(){
        return{
            statistics: null,
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageSize: this.$pageSizes[0],
            },
            listLoading: true,
			downLoading:false
        }
    },
    created(){
        this.getStatistics();
        this.getDataList();
    },
    methods:{
        getStatistics(){
            if(!this.$utils.have('/lottery/activity/statistics')){
                return;
            }
            this.$request({
                url: "/lottery/activity/statistics",
                method: "POST",
                data: {
                    lotteryActivityId: this.$route.query.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.statistics = result;
                    } else {
                        this.$message.error(msg || "请求活动数据失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求活动数据错误");
                })
                .finally(() => {
                    
                });
        },
        //获取列表
        getDataList() {
            if(!this.$utils.have('/lottery/activity/statistics/detail')){
                return;
            }
            this.listLoading = true;
            this.$request({
                url: "/lottery/activity/statistics/detail",
                method: "POST",
                data: {
                    ...this.params,
                    lotteryActivityId: this.$route.query.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },		
		async download(){
		    let filePath;
		    this.downLoading = true;
		    const res = await this.$request({
		        url:'/lottery/activity/export/winAddress',
		        method: 'post',
		        params: {lotteryActivityId: this.$route.query.id },
		    })
		        .catch(err => {
		            this.$message({message: err.message, type: 'error'});
		        })
		    const{state,msg,result} = res.data;
		    if(state == 1 && result){
		        filePath = result.url;
		        
		    }else{
		        this.downLoading = false;
		        return this.$message.error(msg || '导出失败');
		    }   
		
		    await downloadFileTmp(filePath, this.$route.query.id +'中奖地址.'+this.$utils.getFileType(filePath));
		
		    this.downLoading = false;
		},
		
    }
}
</script>
<style lang="scss" scoped>
.statistics-box{
    margin: 20px 0;
    .el-col{
        text-align: center;
        padding: 8px 0;
        .num{
            font-size: 16px;
            margin-bottom: 5px;
        }
    }
}
</style>